import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page7 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="bolds">Policies and Standards:</p>
        <p className="para" style={{ marginTop: "15px" }}>
          The Company has established a variety of policies and standards that
          ensures an enjoyable working environment. During the period of your
          employment with us, you agree to be bound by these policies and
          standards and any future policies and standards that are reasonably
          introduced by the Company.
        </p>
        <p className="para">
          It is agreed that the introduction and administration of these
          policies is within the sole discretion of the Company and that these
          policies do not form a part of this Contract. It is agreed that if the
          Company introduces, amends or deletes employment-related policies as
          conditions warrant then such introduction, deletion or amendment does
          not constitute a breach of this Contract.
        </p>

        <p className="para" style={{ margin: "50px 0 15px 0" }}>
          Confidentiality and Intellectual Property:
        </p>
        <p className="para">
          <span>
            Our offer of employment is conditional upon you agreeing to and
            abiding by the
          </span>{" "}
          <span className="bolds">
            “Confidentiality and Proprietary Information Agreement”
          </span>
          annexed herewith as Schedule “B.”
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Code of Conduct:
        </p>
        <p className="para">
          You shall perform your duties with honesty, integrity and fairness.
          You shall act in good faith, responsibly, with due care, competence
          and diligence, during the term of your employment. You shall act in
          the best interests of the Company and fulfil your service obligations.
          You shall not receive/offer, directly or indirectly, any gifts,
          donations, illegal payments and comparable benefits which are intended
          or perceived to be intended to obtain business (or uncompetitive)
          favours.
        </p>
        <p className="para" style={{ marginTop: "15px" }}>
          You shall:
        </p>
        <p className="para">
          uphold ethical standards of integrity; <br />
          Act objectively and constructively while exercising your duties;{" "}
          <br /> Exercise your responsibilities in a bona-fide manner in the
          interest of the Company; <br />
          Ensure undivided time and attention to your professional obligations
          during business hours; <br /> refrain from any action/practice that
          could lead to a loss of your employment; <br /> Ensure that your
          appearance is neat and groomed at all times when at work.
        </p>
        <p className="bolds" style={{ margin: "20px 0" }}>
          Employment Dispute and Jurisdiction:
        </p>
        <p className="para">
          In the event of any dispute arising out of the interpretation or
          implementation of this employment terms and conditions, this shall be
          referred to arbitration. The parties to this contract shall endeavour
          to mutually agree and decide on the name of a sole arbitrator to
          conduct such arbitration. In the event that the parties cannot reach contract on the name of a sole arbitrator, 
          they agree to approach the Hon’ble High Court of Chennai to 
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
